import React from 'react'
import style from './style.css'

export default class Bubble extends React.Component {
    render(){

        const height = this.props.height || '10px';
        const width = this.props.width || '10px';
        const marginLeft = this.props.marginLeft;
        const marginBottom = this.props.marginBottom;
        const padding = this.props.padding;
        const wrapperWidth = this.props.wrapperWidth;

        return (
            <div className={style.typingIndicatorWrapper}>
                <div className={style.circleGWrapper} style={{marginLeft: marginLeft, padding: padding, width: wrapperWidth, marginBottom: marginBottom}}>
                    <div className={style.circleG_1 + ' ' + style.circleG} style={{height: height, width: width}}></div>
                    <div className={style.circleG_2 + ' ' + style.circleG} style={{height: height, width: width}}></div>
                    <div className={style.circleG_3 + ' ' + style.circleG} style={{height: height, width: width}}></div>
                </div>
            </div>

        )
    }

}

export {Bubble}



// WEBPACK FOOTER //
// ./src/component/TypingIndicator/Bubble/index.js